import { defineComponent as _defineComponent } from 'vue'
import { computed, ref, onMounted } from 'vue';
import { useContext } from '@nuxtjs/composition-api';

interface Props {
  value?: string | null;
}
interface Emits {
  (e: 'search', data: Props['value']): void;
  (e: 'input', data: Props['value']): void;
}

export default /*#__PURE__*/_defineComponent({
  __name: 'UiSearchForm',
  props: {
    value: { default: null }
  },
  emits: ["search", "input"],
  setup(__props: any, { emit }: { emit: ({
  (e: 'search', data: Props['value']): void;
  (e: 'input', data: Props['value']): void;
}), expose: any, slots: any, attrs: any }) {

const props = __props as { value: string | null };





const { i18n } = useContext();

const input = ref();
const placeholder = i18n.t('search_placeholder') as string;
const valueLocal = computed({
  get() {
    return props.value;
  },
  set(newValue) {
    emit('input', newValue);
  },
});

const focusInput = () => input.value.focus();

const search = () => {
  emit('search', valueLocal.value);
};

onMounted(() => {
  focusInput();
});

return { __sfc: true,props, emit, i18n, input, placeholder, valueLocal, focusInput, search }
}

})